import classNames from 'classnames';
import { FC, SVGProps } from 'react';

import ArrowForward from 'assets/icons/arrow_forward.svg';
import ArrowForwardLong from 'assets/icons/arrow_forward_long.svg';
import Email from 'assets/icons/email.svg';
import Phone from 'assets/icons/phone.svg';

import styles from './ActionIcon.module.scss';

export type IconType = 'standard' | 'long' | 'email' | 'telephone';

type ActionIconProps = {
  external?: boolean;
  size?: 'default' | 'small' | 'large';
  className?: string;
  wrapperClass?: string;
  type?: IconType;
};

const IconMap: Record<IconType, FC<SVGProps<SVGSVGElement>>> = {
  long: ArrowForwardLong,
  standard: ArrowForward,
  email: Email,
  telephone: Phone,
};

const ActionIcon = ({
  external = false,
  className,
  wrapperClass,
  size = 'default',
  type = 'standard',
}: ActionIconProps) => {
  const Icon = IconMap[type];

  return (
    <span className={classNames(styles.wrapper, wrapperClass)}>
      <Icon
        className={classNames(styles.icon, className, styles[size], {
          [styles.external]: external,
        })}
      />
    </span>
  );
};

export default ActionIcon;
